import {
  trigger,
  state,
  style,
  transition,
  animate,
} from '@angular/animations';
import { SelectionModel } from '@angular/cdk/collections';
import { Component, Input, ViewChild, OnInit, OnDestroy, SimpleChanges, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSidenav } from '@angular/material/sidenav';
import { MatStepperModule } from '@angular/material/stepper';
import { MatStepper } from '@angular/material/stepper';
import { MatTableDataSource } from '@angular/material/table';
import { Store } from '@ngrx/store';
import { Subject, lastValueFrom, takeUntil } from 'rxjs';
import { BackendApiService } from 'src/app/core/services/backend-api';
import { updateVendorsToMyPurchase } from 'src/app/core/store/form.actions';
import {
  IItemToRequest,
  MyPurchaseForm,
} from 'src/app/shared/models/app-models';
import { Vendor } from 'src/app/shared/models/database-models';
import { AclAslItem, AclAslRecord, AclAslReqDto, AclAslRespDto, AclAslVendor } from './dto/find-acl-asl-req.dto';
import { VendorMaterialGroup } from 'src/app/shared/models/database-models/SaveMyPurchase.model';
import { StepperSelectionEvent } from '@angular/cdk/stepper';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface AslVendorSearchDialogData {
  showPdpMessage: boolean;
}

@Component({
  selector: 'app-asl-vendor-search-dialog',
  templateUrl: './asl-vendor-search-dialog.component.html',
  styleUrls: ['./asl-vendor-search-dialog.component.scss'],
})
export class AslVendorSearchDialogComponent implements OnInit, OnDestroy {
  @ViewChild('aslPg') paginator!: MatPaginator;
  readonly stepperLabels = {
    RECOMMENDED_ACLASL: 'Recommended ACL/ASL',
    INPUT_JUSTIFICATION: 'Input Justification'
  }
  showPdpMessage: boolean = false
  recommendedCurrentPage: number = 0;
  pageSize: number = 5;
  aclaslReq?: AclAslReqDto
  noItemsYet: boolean = true;
  justificationForm: FormGroup = new FormGroup({})
  fields: string[] = []
  expandedElement!: Vendor[] | null;
  pageSizeOptions: number[] = [5, 10, 20, 50];
  recommendedACSLDisplayColumns = [
    'select',
    'vendorName',
    'type',
    'materialSubGroup',
    'itemNos',
    'contactPerson',
    'vendorNo',
    'country'
  ];
  recommendedDataSource = new MatTableDataSource<Vendor>([]);
  recommendedSelection = new SelectionModel<Vendor>(true, []);
  destroy$: Subject<boolean> = new Subject<boolean>();
  materialGroup: string[] = [];
  //true if it is not tender or direct contracting purchase type
  standardPurchaseModeView: boolean = true
  itemMaterialGroupMap: Map<number, string> = new Map<number, string>()
  totalCount: number = 0;
  //chosen vendors
  formVendors: Vendor[] = []
  //full list of vendors
  fullVendorList: Vendor[] = []
  constructor(
    private store: Store<{ form: MyPurchaseForm }>,
    private backendService: BackendApiService,
    public dialogRef: MatDialogRef<AslVendorSearchDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: AslVendorSearchDialogData
  ) {
    this.showPdpMessage = data.showPdpMessage;
    
    // store
    this.store
      .select('form')
      .pipe(takeUntil(this.destroy$))
      .subscribe(async (form: MyPurchaseForm) => {
        console.log(form)
        this.standardPurchaseModeView = form.PurchaseTypeId !== 6 && form.PurchaseTypeId !== 5
        let updateItemMaterialGroupMap = new Map<number, string>()
        let noItemsYet = true
        form.ItemList.forEach((x) => {
          if (!x.isDeleted) noItemsYet = false
          if (x.AddItems.itemId && x.AddItems.MaterialSubGroupId) {
            let materialGroup: any = x.AddItems.MaterialSubGroupId
            updateItemMaterialGroupMap.set(x.AddItems.itemId, materialGroup.value || '')
          }
        })
        this.itemMaterialGroupMap = updateItemMaterialGroupMap
        this.noItemsYet = noItemsYet
        this.materialGroup = form.ItemList.map((item: IItemToRequest) => {
          return item.AddItems.MaterialSubGroupId?.Code ?? '';
        });
        this.formVendors = structuredClone(form.VendorsToSource)
        this.recommendedDataSource.paginator = this.paginator;
        await this.prepareAslAclReqDto(form.ItemList)
      });
  }
  async prepareAslAclReqDto(itemList: IItemToRequest[]) {
    let aclaslRecords: AclAslRecord[] = []
    for (const item of itemList) {
      if (!item.AddItems.MaterialSubGroupId?.Code) continue
      let aclAslItemList: AclAslItem[] = []
      aclAslItemList.push({
        itemId: item.AddItems.itemId,
        itemNumber: item.AddItems.displayItemNumber,
        materialGroupCode: item.AddItems.MaterialSubGroupId?.Code ?? '',
        brandCode: item.AddItems.BrandOEMName?.id ?? null,
        brandOthers: item.AddItems.BrandOEMNameCustom ?? null,
      })
      aclaslRecords.push({
        itemList: aclAslItemList
      })

    }
    this.aclaslReq = { projectItemList: aclaslRecords }
    await this.getData()
  }
  returnConcatenatedMaterialGroups(element: Vendor): string {
    if (!element.vendorMaterialGroup) return ''
    return element.vendorMaterialGroup?.map(x => x.viewSPMaterialGroup.Name).filter(x => x.length > 0).join(',')
  }
  async ngOnInit() {
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
  onRecommendedChange(event: PageEvent): void {
    this.recommendedCurrentPage = event.pageIndex;
    this.pageSize = event.pageSize;
  }
  selectionChange(event: StepperSelectionEvent) {
    let stepLabel = event.selectedStep.label;
    if (stepLabel.includes('Input Justification')) {
      let selectedVendors: Vendor[] = this.getSelected()
      if (selectedVendors.length > 0)
        this.addRecommendedVendor()
    }

  }
  submitAclAslVendors() {
    let selectedVendors: Vendor[] = this.getSelected()
    //should update form field values to selected vendors form justification
    if (selectedVendors.length > 0) {
      for (const newVendor of selectedVendors) {
        let existingVendor = this.formVendors.find(
          (v) => v.VendorNumber == newVendor.VendorNumber && !v.isDeleted && !v.Strikethrough)
        if (existingVendor) {
          if (!this.standardPurchaseModeView && newVendor.Name) {
            let formValue = this.justificationForm.get(newVendor.Name)
            if (formValue) existingVendor.Justification = formValue.getRawValue() || ''
          }
          else
            continue;
        }
        else {
          let vendorName: string = newVendor.Name || ''
          if (vendorName !== null && vendorName.length > 0) {
            let formValue = this.justificationForm.get(vendorName)
            if (formValue) newVendor.Justification = formValue.getRawValue() || ''
          }
          let { vendorMaterialGroup, ...vendorToSave } = structuredClone(newVendor)
          vendorToSave.MPVendorDetailsId = null
          this.formVendors.unshift(vendorToSave)
        }
      }
      this.store.dispatch(updateVendorsToMyPurchase({ vendors: this.formVendors }))
    }
    this.dialogRef.close()
  }
  addRecommendedVendor() {
    if (this.standardPurchaseModeView) {
      this.submitAclAslVendors()
    }
    else {
      let selectedVendors: Vendor[] = this.getSelected()
      if (selectedVendors.length > 0) {
        let updatedFields: string[] = []
        let vendorNames: string[] = selectedVendors.map(x => x.Name ? x.Name : '')
        const formGroupFields: any = {};
        for (const field of vendorNames) {
          let vendor = selectedVendors.find(x => x.Name == field)
          let value = ''
          if (vendor && vendor.Justification) value = vendor.Justification
          formGroupFields[field] = new FormControl(value, [Validators.required]);
          updatedFields.push(field);
        }
        this.fields = updatedFields
        this.justificationForm = new FormGroup(formGroupFields);
      }
    }

  }
  updateSelected() {
    this.recommendedSelection.clear();
    for (const vendor of this.formVendors) {
      if (vendor.Name && (!vendor.isDeleted && !vendor.Strikethrough)) {
        this.recommendedDataSource.data.forEach((row) => {
          if (row.Name == vendor.Name) {
            this.recommendedSelection.select(row)
            if (vendor.Justification) row.Justification = vendor.Justification
          }
        })
      }
    }
  }
  masterVToggle() {
    if (this.isAllVSelected()) {
      this.recommendedSelection.clear();
    } else {
      this.recommendedDataSource.data.forEach((row) =>
        this.recommendedSelection.select(row)
      );
    }
  }

  // function to check if all checkboxes are checked
  isAllVSelected() {
    const numSelected = this.recommendedSelection.selected.length;
    const numRows = this.recommendedDataSource.data.length;
    return numSelected === numRows;
  }

  isVselected() {
    if (this.recommendedSelection.selected.length !== 0) return true;
    return false;
  }


  // checkbox toggling
  onCheckboxChange($event: any, row: any) {
    $event ? this.recommendedSelection.toggle(row) : null;
  }

  async getData() {
    try {
      if (this.aclaslReq) {
        const vendorListObj: AclAslVendor[] = await lastValueFrom(this.backendService.getACLASLVendors(this.aclaslReq!))
        const vendorList: Vendor[] = this.transformAclAslRecord(vendorListObj)
        this.recommendedDataSource = new MatTableDataSource<Vendor>(
          vendorList
        );
        this.totalCount = vendorList.length;
        this.updateSelected();
      }


    } catch (e) {
      alert('Error retrieving acl/asl vendors')
      throw Error('Error from backend');
    }
  }

  transformAclAslRecord(vendorListObj: AclAslVendor[]) {

    let frontEndVendorArr = vendorListObj.map((vendor) => {
      let itemNumbers: string =
        vendor.ItemNumbers && vendor.ItemNumbers.length > 0
          ? vendor.ItemNumbers.join(',')
          : '';
      let vendorMaterialGroup: VendorMaterialGroup[] = [
        {
          BrandCode: vendor.BrandCode || '',
          VendorDistributionTypeCode: '',
          viewSPMaterialGroup: {
            Name: vendor.MaterialSubGroup || '',
          },
        },
      ];
      return {
        Name: vendor.VendorName,
        VendorNumber: vendor.VendorNumber,
        AddressCountryCode: vendor.Country,
        ContactPersonID:vendor.ContactPersonID,
        EmailAddress: vendor.EmailAddress,
        VendorStatusID: vendor.VendorStatusID?.toString() ?? null,
        IsPerm: vendor.IsPerm ?? true,
        VendorGEWCAs: vendor.VendorGEWCAs ?? [],
        VendorStatus: vendor.VendorStatus,
        MPVendorDetailsId: vendor.VendorId,
        isDeleted: false,
        vendorMaterialGroup: vendorMaterialGroup,
        Justification: '',
        VendorContactPersonFullName: `${vendor.ContactPersonFirstName || ''} ${vendor.ContactPersonLastName || ''
          }`,
        Email: vendor.EmailAddress || '',
        VendorContactPerson: `${vendor.ContactPersonFirstName || ''} ${vendor.ContactPersonLastName || ''
          }`,
        ItemNos: itemNumbers || '',
        Strikethrough: false
      };
    });

    return frontEndVendorArr;
  }
  getSelected() {
    let vendors: Vendor[] = []
    for (const item of this.recommendedSelection.selected) {
      vendors.push(item)
    }
    return vendors
  }
}
export interface RecommendedACSL {
  id: number;
  vendorName: string;
  type: string;
  materialSubGroup: string;
  brand: string;
  distributionType: string;
}
